import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ModelConfig } from '@ca/core/models';

@Injectable({
    providedIn: 'root',
})
export class MLModelService {
    private readonly API_URL = '/api/documents/mlmodel';
    private readonly HEADERS = { 'Content-Type': 'application/json' };

    constructor(protected http: HttpClient) {}

    createSettingsFile$(modelId: string, inputImages: string[]): Observable<string> {
        return this.http.post<string>(`${this.API_URL}/${modelId}/settings`, { images: inputImages }, { headers: this.HEADERS });
    }

    getConfig$(modelId: string): Observable<ModelConfig> {
        return this.http.get<ModelConfig>(`${this.API_URL}/${modelId}/config`, { headers: this.HEADERS });
    }
}
